export class ReportEvent {
  event_name: string;
  creation_datetime: string;
  occurrence_datetime: string;
  displayName: string;
  booking_number: number;
  id_cabin: string;
  badge_number: number;
  number_of_users: number;
  has_checkin: string;
  status: string;

  constructor(
    event_name: string,
    creation_datetime: string,
    occurrence_datetime: string,
    displayName: string,
    booking_number: number,
    badge_number: number,
    number_of_users: number,
    has_checkin: number,
    is_waiting_list: number,
    id_cabin: string
  ) {
    this.event_name = event_name;
    this.creation_datetime = creation_datetime;
    this.occurrence_datetime = occurrence_datetime;
    this.displayName = displayName;
    this.booking_number = booking_number;
    this.badge_number = badge_number;
    this.number_of_users = number_of_users;
    this.has_checkin = has_checkin == 1 ? 'Sì' : 'No';
    this.status = is_waiting_list == 1 ? 'Lista di attesa' : 'Confermata';
    this.id_cabin = id_cabin;
  }
}
